import { FC } from 'react';

import ConfirmMagicLinkLogin from '@/components/layout/loginPage/ConfirmMagicLinkLogin.tsx';

const MagicLinkActivationPage: FC = () => {
  return (
    <div>
      <div>
        <div className="flex overflow-hidden relative flex-col items-center text-center h-screen px-16 pt-20 min-h-screen bg-white max-md:px-5">
          <div className="relative max-w-full w-[450px] max-md:mt-10 mt-72">
            <div className="w-full max-md:w-full">
              <div className="relative grow px-10 pt-10 pb-20 w-full text-xs bg-white rounded-3xl max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <ConfirmMagicLinkLogin />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagicLinkActivationPage;
